import { useEffect, useRef } from 'react';
import { useOutsideClick } from '../hooks/useOutsideClick';

interface PickerProps {
  children: React.ReactNode;
  onClickOutSide?: () => void;
}

const Picker = ({ children, onClickOutSide }: PickerProps) => {
  const pickerRef = useRef<HTMLDivElement>(null);

  useOutsideClick({ ref: pickerRef, handler: onClickOutSide });

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        position: 'fixed',
        left: 0,
        zIndex: 100,
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'fixed',
          top: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        }}
      ></div>
      <div
        style={{
          position: 'fixed',
          bottom: 0,
          width: '100%',
          backgroundColor: 'white',
          borderTopLeftRadius: '15px',
          borderTopRightRadius: '15px',
          padding: '10px 0 20px 0',
          transform: 'translateY(100%)',
          animation: 'slideUp 0.3s forwards',
        }}
        ref={pickerRef}
      >
        <div
          style={{
            margin: '10px auto',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Picker;
